import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    }, 1500);
  };
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-496">
      {/* Hero Section */}
      <section className="bg-blue-600 text-white py-16" data-id="element-497">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-498">
          <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-499">Contact Us</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto" data-id="element-500">
            Have questions or feedback? We'd love to hear from you.
          </p>
        </div>
      </section>
      {/* Contact Section */}
      <section className="py-16" data-id="element-501">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-502">
          <div className="grid md:grid-cols-3 gap-8" data-id="element-503">
            {/* Contact Info */}
            <div className="md:col-span-1" data-id="element-504">
              <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-505">
                <h2 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-506">
                  Get In Touch
                </h2>
                <div className="space-y-6" data-id="element-507">
                  <div className="flex items-start" data-id="element-508">
                    <div className="flex-shrink-0" data-id="element-509">
                      <Mail className="h-6 w-6 text-blue-600" data-id="element-510" />
                    </div>
                    <div className="ml-3 text-gray-600" data-id="element-511">
                      <p className="text-sm font-medium text-gray-900" data-id="element-512">Email</p>
                      <p data-id="element-513">info@goabitfurtherafrica.site</p>
                      <p data-id="element-514">partner@goabitfurtherafrica.site</p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-515">
                    <div className="flex-shrink-0" data-id="element-516">
                      <Phone className="h-6 w-6 text-blue-600" data-id="element-517" />
                    </div>
                    <div className="ml-3 text-gray-600" data-id="element-518">
                      <p className="text-sm font-medium text-gray-900" data-id="element-519">Phone</p>
                      <p data-id="element-520">+2348127476613</p>
                      <p data-id="element-521">+2348146058386</p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-522">
                    <div className="flex-shrink-0" data-id="element-523">
                      <MapPin className="h-6 w-6 text-blue-600" data-id="element-524" />
                    </div>
                    <div className="ml-3 text-gray-600" data-id="element-525">
                      <p className="text-sm font-medium text-gray-900" data-id="element-526">
                        Office
                      </p>
                      <p data-id="element-527">Lagos, Nigeria</p>
                      <p data-id="element-528">Benin, Nigeria</p>
                      <p data-id="element-529">Abuja, Nigeria</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-530">
                <h2 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-531">
                  Follow Us
                </h2>
                <div className="flex space-x-4" data-id="element-532">
                  <a href="https://web.facebook.com/GoABitFurtherAfrica" target="_blank" rel="noopener noreferrer" className="bg-blue-100 p-3 rounded-full text-blue-600 hover:bg-blue-200" data-id="element-533">
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-534">
                      <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" data-id="element-535" />
                    </svg>
                  </a>
                  <a href="https://x.com/goabitfurther" target="_blank" rel="noopener noreferrer" className="bg-blue-100 p-3 rounded-full text-blue-600 hover:bg-blue-200" data-id="element-536">
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-537">
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723 10.054 10.054 0 01-3.127 1.184 4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" data-id="element-538" />
                    </svg>
                  </a>
                  <a href="https://instagram.com/goabitfurtherafrica" target="_blank" rel="noopener noreferrer" className="bg-blue-100 p-3 rounded-full text-blue-600 hover:bg-blue-200" data-id="element-539">
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-540">
                      <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" data-id="element-541" />
                    </svg>
                  </a>
                  <a href="https://www.linkedin.com/company/goabitfurtherafrica/" target="_blank" rel="noopener noreferrer" className="bg-blue-100 p-3 rounded-full text-blue-600 hover:bg-blue-200" data-id="element-542">
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-543">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-544" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            {/* Contact Form */}
            <div className="md:col-span-2" data-id="element-545">
              <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-546">
                <h2 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-547">
                  Send Us a Message
                </h2>
                {submitted ? <div className="bg-green-50 border-l-4 border-green-500 p-4 mb-6" data-id="element-548">
                    <div className="flex" data-id="element-549">
                      <div data-id="element-550">
                        <p className="text-green-700 font-medium" data-id="element-551">
                          Thank you for your message!
                        </p>
                        <p className="text-green-600 mt-1" data-id="element-552">
                          We'll get back to you as soon as possible.
                        </p>
                      </div>
                    </div>
                  </div> : <form onSubmit={handleSubmit} action="https://formspree.io/f/xjkakzdq" method="POST" data-id="element-553">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6" data-id="element-554">
                      <div data-id="element-555">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-556">
                          Your Name
                        </label>
                        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-557" />
                      </div>
                      <div data-id="element-558">
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-559">
                          Your Email
                        </label>
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-560" />
                      </div>
                    </div>
                    <div className="mb-6" data-id="element-561">
                      <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-562">
                        Subject
                      </label>
                      <select id="subject" name="subject" value={formData.subject} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-563">
                        <option value="" data-id="element-564">Select a subject</option>
                        <option value="Course Inquiry" data-id="element-565">Course Inquiry</option>
                        <option value="Technical Support" data-id="element-566">
                          Technical Support
                        </option>
                        <option value="Partnership Opportunity" data-id="element-567">
                          Partnership Opportunity
                        </option>
                        <option value="Feedback" data-id="element-568">Feedback</option>
                        <option value="Other" data-id="element-569">Other</option>
                      </select>
                    </div>
                    <div className="mb-6" data-id="element-570">
                      <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-571">
                        Your Message
                      </label>
                      <textarea id="message" name="message" rows={6} value={formData.message} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-572"></textarea>
                    </div>
                    <div data-id="element-573">
                      <button type="submit" disabled={isSubmitting} className="w-full flex justify-center items-center px-4 py-3 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-300" data-id="element-574">
                        {isSubmitting ? <span data-id="element-575">Sending...</span> : <>
                            <Send className="mr-2 h-5 w-5" data-id="element-576" />
                            Send Message
                          </>}
                      </button>
                    </div>
                  </form>}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="py-16 bg-white" data-id="element-577">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-578">
          <div className="text-center mb-12" data-id="element-579">
            <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-580">
              Frequently Asked Questions
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-581">
              Find answers to common questions about our platform and courses.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-582">
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-583">
              <h3 className="text-lg font-semibold text-gray-800 mb-3" data-id="element-584">
                How much does it cost to join?
              </h3>
              <p className="text-gray-600" data-id="element-585">
                Basic access to our platform is completely free. Some premium
                courses and features may require a subscription, but we offer
                scholarships for students who demonstrate need.
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-586">
              <h3 className="text-lg font-semibold text-gray-800 mb-3" data-id="element-587">
                Do I get a certificate after completing a course?
              </h3>
              <p className="text-gray-600" data-id="element-588">
                Yes! Upon successful completion of a course and its assessments,
                you'll receive a downloadable certificate that you can add to
                your resume and LinkedIn profile.
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-589">
              <h3 className="text-lg font-semibold text-gray-800 mb-3" data-id="element-590">
                How long do courses typically take to complete?
              </h3>
              <p className="text-gray-600" data-id="element-591">
                Most courses are designed to be completed in 4-6 weeks with 2-3
                hours of study per week. However, you can learn at your own pace
                and take as much time as you need.
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-592">
              <h3 className="text-lg font-semibold text-gray-800 mb-3" data-id="element-593">
                Can I access courses on mobile devices?
              </h3>
              <p className="text-gray-600" data-id="element-594">
                Absolutely! Our platform is fully responsive and works on
                smartphones and tablets, allowing you to learn on the go.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Contact;